module.exports = __webpack_public_path__ + "img/hero02__1615360295_203.109.44.209.6ab2ffaf.jpg";